var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes()},[_c('VueCountUp',{attrs:{"delay":_vm.delay,"endVal":_vm.endVal,"options":_vm.options},on:{"ready":_vm.onReady}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }